/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import styled from 'styled-components';
import {Collapsible, FontSizes, FontWeights, Text, minWidth} from '@calm-web/design-system';
import {FaqItem} from '../../FAQ/styles';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    p: "p",
    a: "a",
    ul: "ul",
    li: "li",
    ol: "ol"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "GENERAL"
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is Calm?',
      children: _jsxs(_components.p, {
        children: ["Calm is the #1 mental health app designed to help you manage stress, sleep better, and live a happier,\nhealthier life. Our research-based tools help you build life-changing habits to support your mental health.\nIf you're having trouble falling asleep, our 500+ ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), "®, soundscapes, and guided ", _jsx(_components.a, {
          href: "/app/sleep/meditations",
          children: "sleep meditations"
        }), "\ncan lull you to sleep. If you're spiraling in negative thoughts and need immediate relief, our 60-second\nBreathe Bubble grounds you in the moment and helps your body return to a state of relaxation. If you're\noverwhelmed at work and need a breather, our ", _jsx(_components.a, {
          href: "/app/class/work-managing-overwhelm",
          children: "stress and burnout specialists"
        }), " can guide you through exercises\nto help calm your mind. We're here for you whenever or wherever you need us with more content and tools\nbeing added monthly."]
      })
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: "What's included in a Calm subscription?",
      children: [_jsxs(_components.p, {
        children: ["A Calm subscription unlocks our full library of ", _jsx(_components.a, {
          href: "/app/class/meditate-quick-and-easy",
          children: "meditations"
        }), ", ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), ", ", _jsx(_components.a, {
          href: "/app/music",
          children: "music"
        }), ", and other features. The\nsubscription includes:"]
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Multiple original ", _jsx(_components.a, {
            href: "/app/dailies",
            children: "daily offerings"
          }), " from a range of teachers to give your day a dose of wisdom, gratitude and encouragement"]
        }), "\n", _jsxs(_components.li, {
          children: ["Hours of ", _jsx(_components.a, {
            href: "/app/class/meditate-quick-and-easy",
            children: "guided meditations"
          }), " covering sleep, anxiety, stress, gratitude, and much more"]
        }), "\n", _jsxs(_components.li, {
          children: ["Our entire library of more than 500+ ", _jsx(_components.a, {
            href: "/app/class/sleep-popular-sleep-stories",
            children: "Sleep Stories"
          }), ", with new stories added every week"]
        }), "\n", _jsxs(_components.li, {
          children: ["Exclusive ", _jsx(_components.a, {
            href: "/app/music",
            children: "music"
          }), " tracks for focus, relaxation, and sleep"]
        }), "\n"]
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'Where should I get started once I download the app?',
      children: [_jsxs(_components.p, {
        children: ["If you have come to Calm to learn relaxation techniques and improve aspects of your mental health, we\nrecommend beginning with the ", _jsx(_components.a, {
          href: "/app/program/qK3IeqhiJP",
          children: "7 Days of Calm"
        }), ", our introductory program that offers the basics of meditation,\nand then move on to the ", _jsx(_components.a, {
          href: "/app/program/YAcrQol9Wv",
          children: "21 Days of Calm"
        }), ". With that foundation, you can explore our library of sessions and\nprograms, which address themes such as ", _jsx(_components.a, {
          href: "/app/meditate/anxiety",
          children: "anxiety"
        }), ", ", _jsx(_components.a, {
          href: "/app/sleep",
          children: "sleep"
        }), ", ", _jsx(_components.a, {
          href: "/app/meditate/focus",
          children: "focus"
        }), ", and ", _jsx(_components.a, {
          href: "/app/meditate/self-care",
          children: "gratitude"
        }), ". Additionally, for moments of\nacute stress or anxiety, we offer in-the-moment calming exercises via our ", _jsx(_components.a, {
          href: "/app/program/_kCx96PwDb",
          children: "Panic SOS"
        }), ", ", _jsx(_components.a, {
          href: "/app/program/whzIxMJxVR",
          children: "Body Scan"
        }), ", and\nbreathing exercise features."]
      }), _jsxs(_components.p, {
        children: ["If you have come to Calm to improve your sleep, we have a collection of over 500 ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), " to help you drift off to restful sleep, ranging from ", _jsx(_components.a, {
          href: "/app/player/h5JpJ0Fqb2",
          children: "classic literature"
        }), " to ", _jsx(_components.a, {
          href: "/app/class/tagged-sleep-nature",
          children: "nature essays"
        }), ",\n", _jsx(_components.a, {
          href: "/app/class/tagged-sleep-kids",
          children: "children's tales"
        }), ", scientific articles, and more. We update our Sleep Stories selection with new options to\nlisten to every week. We also have a collection of soothing Sleep Music."]
      })]
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What devices support the Calm app?',
      children: _jsx(_components.p, {
        children: "Calm is available on iOS, Android, Web, in addition to Apple TV, Apple Watch,\nGoogle WearOS, and Samsung Health."
      })
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do I cancel?',
      children: [_jsx(_components.p, {
        children: "You can cancel your Calm subscription's auto-renewal or free trial at any time."
      }), _jsx(_components.p, {
        children: "To cancel your Calm subscription:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Tap 'Profile' on your app's Home screen."
        }), "\n", _jsx(_components.li, {
          children: "Tap the 'Settings' gear icon in the top left corner of your screen."
        }), "\n", _jsx(_components.li, {
          children: "Tap 'Manage Subscription' and follow the instructions here to cancel your subscription."
        }), "\n", _jsx(_components.li, {
          children: "For subscriptions purchased through Apple and Google Play, tap the word 'here' on your Manage Subscription page to be redirected to your device's subscription settings."
        }), "\n"]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "MEDITATION & MINDFULNESS"
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is meditation?',
      children: [_jsx(_components.p, {
        children: "Meditation is the practice of allowing thoughts to come and go, as you learn to recognize and release them\nwithout judgment. Studies show that a long-term meditation practice can actually help shift your nervous\nsystem out of fight or flight and into the relaxed parasympathetic mode producing a wide array of benefits*\nincluding:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Decreased anxiety and depression symptoms"
        }), "\n", _jsx(_components.li, {
          children: "Chronic pain management"
        }), "\n", _jsx(_components.li, {
          children: "Lower stress levels"
        }), "\n", _jsx(_components.li, {
          children: "Improved sleep quality"
        }), "\n"]
      })]
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is mindfulness?',
      children: _jsx(_components.p, {
        children: "Mindfulness is a practice that involves intentionally bringing one's attention and awareness to the present\nmoment without judgment. It's about being fully present and engaged in the here and now, rather than\ndwelling on the past or worrying about the future. Mindfulness encourages a non-judgmental attitude towards\none's thoughts, emotions and sensations, allowing them to arise and pass without any added stress. By\ncultivating mindfulness, people often develop a greater sense of clarity, calmness and overall wellbeing, as\nwell as enhance their ability to respond skillfully to the challenges of life."
      })
    }), "\n", _jsx(_components.h3, {
      children: "STRESS & ANXIETY"
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What causes stress and anxiety?',
      children: [_jsx(_components.p, {
        children: "Stress and anxiety can have various causes and can differ greatly from person to person. Here are a few common factors that contribute to stress and anxiety:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Major life changes: Significant life events such as moving, getting married (or divorced), starting a new job or experiencing the loss of a loved one can trigger it."
        }), "\n", _jsx(_components.li, {
          children: "Work or school pressure: High workloads, tight deadlines, challenging bosses, or work pressure can lead to stress and anxiety."
        }), "\n", _jsx(_components.li, {
          children: "Financial challenges: Job loss, debt, or just struggling to make ends meet can be a significant source of stress and anxiety."
        }), "\n", _jsx(_components.li, {
          children: "Relationships: Whether romantic, familial or social, strain or conflict in relationships can cause stress and anxiety."
        }), "\n", _jsx(_components.li, {
          children: "Health concerns: Managing chronic illness, physical pain or battling a health condition can be a cause, as well."
        }), "\n", _jsx(_components.li, {
          children: "Traumatic experiences: Experiencing a traumatic event, such as an accident, abuse or even a natural disaster can lead to anxiety-related conditions."
        }), "\n", _jsx(_components.li, {
          children: "Uncertainty and change: Experiencing frequent change (even positive change!) or feeling uncertain about the future can be a common cause of anxiety."
        }), "\n"]
      }), _jsx(_components.p, {
        children: "It's important to note that not everyone experiences stress and anxiety in the same way. If you're dealing with stress and anxiety, it's recommended to seek support from a mental health professional who can provide personalized guidance."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How can I manage my stress and anxiety?',
      children: [_jsx(_components.p, {
        children: "Once you're in the Calm app, we recommend using a Breathing Bubble exercise if you're looking for immediate stress or anxiety relief. Breathwork elicits the body's relaxation response which reduces tension and lowers stress."
      }), _jsxs(_components.p, {
        children: ["We also have other content programs, including our ", _jsx(_components.a, {
          href: "/app/program/3ePnY22GC6",
          children: "Overcome Stress and Anxiety"
        }), " collection in partnership with clinical psychologist, Dr. Julie Smith. In this series, Dr. Julie guides listeners through high stress moments in real time, including panic attacks, negative thought spirals, and more."]
      }), _jsxs(_components.p, {
        children: ["In addition to Dr. Julie's series, you can find more guided breathing exercises and meditations in our ", _jsx(_components.a, {
          href: "/app/meditate/anxiety",
          children: "Reduce Stress & Anxiety"
        }), " collection. Let experts such as ", _jsx(_components.a, {
          href: "/app/class/popular-daily-jay",
          children: "Jay Shetty"
        }), ", ", _jsx(_components.a, {
          href: "/app/class/practice-tips-with-tamara",
          children: "Tamara Levitt"
        }), ", and ", _jsx(_components.a, {
          href: "/app/player/0ADJHJs5a6",
          children: "Chibs Okereke"
        }), " help guide you into peaceful mindfulness and relaxation."]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "SLEEP"
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'Why do I have trouble sleeping?',
      children: [_jsx(_components.p, {
        children: "There can be various reasons why you may be experiencing trouble sleeping. Here are a few common factors that can contribute to sleep difficulties:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Stress and Anxiety: High levels of stress or anxiety can make it difficult to relax and fall asleep. Racing thoughts, worry, or an overactive mind can keep you awake at night."
        }), "\n", _jsx(_components.li, {
          children: "Poor Sleep Habits: Irregular sleep patterns, inconsistent bedtime routines, excessive caffeine or alcohol consumption, and engaging in stimulating activities before bed can disrupt your sleep."
        }), "\n", _jsx(_components.li, {
          children: "Environmental Factors: Uncomfortable sleeping environment, excessive noise, extreme temperatures, or inadequate lighting can interfere with your ability to fall asleep or stay asleep."
        }), "\n", _jsx(_components.li, {
          children: "Medical Conditions: Certain medical conditions, such as chronic pain, sleep apnea, restless leg syndrome, or hormonal imbalances, can disrupt your sleep."
        }), "\n", _jsx(_components.li, {
          children: "Mental Health Issues: Depression, bipolar disorder, post-traumatic stress disorder (PTSD), and other mental health disorders can affect sleep patterns and quality."
        }), "\n"]
      }), _jsx(_components.p, {
        children: "If you're consistently having trouble sleeping, it's advisable to consult with a healthcare professional who can help assess your specific situation and provide guidance that's tailored to your needs."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How can I sleep better naturally?',
      children: [_jsxs(_components.p, {
        children: ["In the Calm app, we recommend starting with our Fall Asleep collection, which features our most popular ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), "®, ", _jsx(_components.a, {
          href: "/app/class/music-mood-wind-down",
          children: "soundscapes"
        }), ", ", _jsx(_components.a, {
          href: "/app/music",
          children: "music"
        }), ", and ", _jsx(_components.a, {
          href: "/app/meditate",
          children: "meditations"
        }), " based on your goals:"]
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Help falling asleep: natural sleep aids"
        }), "\n", _jsx(_components.li, {
          children: "Getting back to sleep: reactive tools used to soothe and lull you back to sleep"
        }), "\n", _jsx(_components.li, {
          children: "Unwinding before bed: proactive tools to help start a sleep routine and focuses on sleep hygiene - this means focusing on building habits and an environment designed for optimal sleep"
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Our most popular sleep offering is our ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), "®, which are bedtime stories designed to help you drift off to sleep. Many of our narrators are also names you may already be familiar with, from artists like ", _jsx(_components.a, {
          href: "/app/player/2QQEAZ7IsG",
          children: "Harry Styles"
        }), " and ", _jsx(_components.a, {
          href: "/app/program/nVKU_KxPlm",
          children: "Michael Bublé"
        }), " to actors and actresses such as ", _jsx(_components.a, {
          href: "/app/player/TvmOdIeBVj",
          children: "Jennifer Garner"
        }), " and ", _jsx(_components.a, {
          href: "/app/feeds/narrator-u141IqAGf",
          children: "Matthew McConaughey"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["With over 500 Sleep Stories® in our library, we have a library fit for both adults and kids, making our app something the whole family can enjoy. Kids can enjoy exclusive Sleep Stories® featuring favorite characters such as ", _jsx(_components.a, {
          href: "/app/player/NK30cxIQzy",
          children: "Peppa Pig"
        }), ", ", _jsx(_components.a, {
          href: "/app/player/sjWv03z4KI",
          children: "Minions"
        }), ", ", _jsx(_components.a, {
          href: "/app/program/SjF_l5VVyT",
          children: "Winnie the Pooh"
        }), ", ", _jsx(_components.a, {
          href: "/app/player/YHgB8hl8yN",
          children: "Transformers"
        }), ", and more."]
      }), _jsxs(_components.p, {
        children: ["In addition to Sleep Stories®, we also have soothing soundscapes and music that have been sonically-engineered to help you sleep. Choose from nature sounds such as ", _jsx(_components.a, {
          href: "/app/player/1nLymYtw9L",
          children: "rainstorms"
        }), " and ", _jsx(_components.a, {
          href: "/app/player/D7lklLoUJ",
          children: "ocean waves"
        }), ", to different frequency pitches including ", _jsx(_components.a, {
          href: "/app/player/61i9y0yxqI",
          children: "white"
        }), ", ", _jsx(_components.a, {
          href: "/app/player/cqa16VacfZ",
          children: "brown"
        }), ", and ", _jsx(_components.a, {
          href: "/app/player/VI5Swv6gaz",
          children: "green"
        }), " noise. With over 500 different options and new offerings being added monthly, our Sleep Sounds library has something for everyone—whether you're looking to relax, focus, or fall asleep."]
      }), _jsx(_components.p, {
        children: "If you're looking for something that provides a bit more guidance, Calm also offers a variety of sleep meditations and breathwork. These exercises help lower the heart rate, which shifts your nervous system out of fight or flight and into a relaxed parasympathetic mode, enabling your body to fall into a deeper sleep."
      }), _jsx(_components.p, {
        children: "Lastly, we also have a Sleep Check-In feature which offers a new way to track your sleep. Check in with your nightly sleep quality, and we'll show you patterns to guide you towards better sleep habits and health."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'Are Sleep Stories® good for kids and adults?',
      children: [_jsx(_components.p, {
        children: "Absolutely! In a Calm Science study of 900+ parents (US) who use Calm Kids with their kids at least once a week, parents reported they had lower stress and slept better, and that their kids fell asleep faster and had less stress and anxiety."
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "74% felt that Calm Kids helped lower their parenting-stress"
        }), "\n", _jsx(_components.li, {
          children: "63% felt that Calm Kids helped their own sleep"
        }), "\n", _jsx(_components.li, {
          children: "95% say Calm Kids Sleep Stories® help their child fall asleep faster"
        }), "\n", _jsx(_components.li, {
          children: "75% say Calm Kids meditations help their child"
        }), "\n"]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "SOUNDSCAPES"
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do different sound frequencies affect your brain?',
      children: [_jsx(_components.p, {
        children: "Although it's commonly known now that there are different 'colors' of noises, it might not be known what the difference between them are. Different types of noise have distinct frequency characteristics, which means that the energy of the sound is distributed differently across the frequency spectrum. As a result, how you perceive each noise can affect the use-case of each frequency."
      }), _jsx(_components.p, {
        children: "White noise has equal power in every frequency band, between 20 hertz and 20,000 hertz, and gives your brain something relaxing to focus on; this can help block out distractions and make it perfect for sleep. Similarly, brown noise has more energy at lower frequencies, giving it a deep, 'booming' noise. It is commonly used for relaxation and sleep."
      }), _jsx(_components.p, {
        children: "Pink noise has less energy at higher frequencies. Pink noise is often described as having a \"fuller\" sound compared to white noise. Naturally occurring examples of pink noise are rustling leaves, wind, and heartbeats."
      }), _jsx(_components.p, {
        children: "Lastly, it is theorized that green noise is calming because it simulates the spectrum of natural noise without human-made noises; this noise has more energy at mid-range frequencies and is sometimes used in sound masking for tinnitus."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do binaural beats help improve focus and reduce anxiety?',
      children: [_jsx(_components.p, {
        children: "Binaural beats are a type of sound therapy that involves playing two different tones in each ear, creating a perceived beat frequency that is thought to affect brain waves. The idea is that when the brain hears two slightly different frequencies, it tries to \"reconcile\" them by producing a third frequency that is the difference between the two. This is known as the \"frequency following response,\" and it is believed to influence brain waves in a way that can be beneficial for focus and relaxation."
      }), _jsx(_components.p, {
        children: "Some research suggests that listening to binaural beats can help improve focus and reduce anxiety by promoting a state of relaxation and reducing stress levels. One theory is that binaural beats can influence the production of alpha waves in the brain, which are associated with relaxation and reduced anxiety."
      }), _jsx(_components.p, {
        children: "Another theory is that binaural beats can help entrain the brain to a specific frequency associated with improved focus or creativity. For example, some studies have suggested that listening to binaural beats in the alpha or theta frequency range can help improve cognitive performance and enhance creativity."
      }), _jsx(_components.p, {
        children: "However, while some research has shown potential benefits of binaural beats for certain conditions, such as anxiety and depression, the evidence is not yet conclusive."
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
